<template>
  <div id="wrapper">
    <div :class="{'nav-open': $sidebar.showSidebar}">
    <router-view></router-view>
    <!-- Mobile Sidebar -->
    <side-bar :type="'navbar'" :sidebar-links="$sidebar.sidebarLinks">
      <ul class="nav navbar-nav">
        <li class="nav-item">
          <router-link class="nav-link" :to="'account'">
            <p>
              <i class="fa fa-fw fa-user"></i> My Account
            </p>
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link interactive-cursor" @click="logout()">
            <p>
              <i class="fa fa-fw fa-sign-out-alt"></i> Logout
            </p>
          </a>
        </li>
        <li class="divider"></li>
      </ul>
    </side-bar>
  </div>
    <transition-group name="expand">
      <template v-for="(modal, index) in modals">
        <modal-form v-if="modal.permalink"
          :key="index"
          :permalink="modal.permalink"
          :data="modal.data"
          :options="modal.options"
          :params="modal.params"
          :index="index"
          @change="update(modal.data, $event)">
        </modal-form>
        <modal v-else-if="!modal.alreadyOpen" 
          :is-open="true" 
          :title="modal.title" 
          :key="index">
          <div v-html="modal.html"></div>
          <div slot="footer">
            <button type="button" class="btn btn-success"
              @click="closeModal(index)">
              Dismiss
            </button>
          </div>
        </modal>
      </template>
    </transition-group>
    <div class="modal-backdrop fade show" v-show="showBackDrop"></div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex'
  import ModalForm from '@/components/ui/ModalForm'
  import Modal from '@/components/ui/Modal'
  import SideBar from '@/components/ui/SideBar.vue'
  import dom from '@/util/dom'
  import {
    LOGOUT
  } from '@/vuex/types'

  export default {
    name: 'App',
    components: {
      Modal,
      ModalForm,
      SideBar
    },
    computed: {
      showBackDrop () {
        let alreadyOpen = this.modals.find(el => el.alreadyOpen)
        if (this.modals.length && !alreadyOpen) {
          return true
        } else {
          return false
        }
      },
      ...mapGetters([
        'modals',
        'isLoggedIn',
        '$sidebar'
      ])
    },
    data () {
      return {
        fromPath: '/',
        failedLogin: false
      }
    },
    async mounted () {
      await this.checkLoginStatus(this.isLoggedIn)
      this.checkPermissions()
    },
    watch: {
      $route () {
        this.checkPermissions()
      },
      modals ({ length }) {
        if (length > 0) {
          dom(this.$root.$el.parentElement).addClass('modal-open')
        } else {
          dom(this.$root.$el.parentElement).removeClass('modal-open')
        }
      },
      isLoggedIn (loggedIn) {
        this.checkLoginStatus(loggedIn)
      }
    },
    methods: {
      checkPermissions () {
        if (!this.$route.meta.client && this.$route.path !== '/') {
          if (!this.$user.staff) this.$router.push('/404')
        }
      },
      async checkLoginStatus (loggedIn) {
        if (loggedIn) {
          await this.$user.refreshUser()
        } else {
          this.$user.logout()
        }
        if (!loggedIn && this.$router.currentRoute.path !== '/login' && this.$router.currentRoute.path !== '/forgot-password' && !this.$router.currentRoute.path.includes('/reset-password/') && !this.$router.currentRoute.path.includes('/feed-back/')) {
          this.fromPath = this.$router.currentRoute.fullPath
          this.failedLogin = true
          this.$router.push('/login')
        } else if (loggedIn && this.fromPath !== '/') {
          let redirect = this.fromPath
          this.fromPath = '/'
          await this.$nextTick()
          this.$router.replace(redirect)
        }
      },
      ...mapMutations([
        'closeModal'
      ]),
      async logout () {
        this.$user.logout()
        await this.$store.dispatch(LOGOUT)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/App.vue